<span *ngIf="showTimer" style=" margin-right: 2px; display: flex; align-items: center;">
    (<span *ngIf="showMin"><i>{{minute}}:</i></span><span><i>{{secend}}</i></span>)
</span>
